module.exports = __webpack_public_path__ + "img/26.d65aa172.png";